import React from "react";
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";

const ProjectsCard = ({ title, des, src, github, live }) => {
  return (
    <div className="w-full p-4 xl:px-8 h-auto rounded-2xl shadow-lg flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:from-gray-900 hover:to-gray-900 transition-all duration-700 hover:shadow-xl hover:shadow-designColor/20">
      {/* Image */}
      <div className="w-full h-60 overflow-hidden rounded-xl relative">
        <img
          className="w-full h-full object-cover group-hover:scale-110 duration-500 cursor-pointer"
          src={src}
          alt="project"
        />
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-70 transition-all duration-500 flex items-center justify-center gap-4 opacity-0 group-hover:opacity-100">
          <a
            href={github}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xl w-12 h-12 rounded-full bg-designColor flex justify-center items-center text-white hover:bg-white hover:text-designColor duration-300 transform translate-y-4 group-hover:translate-y-0 transition-transform"
          >
            <BsGithub />
          </a>
          <a
            href={live}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xl w-12 h-12 rounded-full bg-designColor flex justify-center items-center text-white hover:bg-white hover:text-designColor duration-300 transform translate-y-4 group-hover:translate-y-0 transition-transform delay-100"
          >
            <FaGlobe />
          </a>
        </div>
      </div>

      {/* Text */}
      <div className="w-full mt-5 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg uppercase font-semibold text-designColor group-hover:text-white transition-colors duration-300">
            {title}
          </h3>
          <div className="flex gap-3">
            <a
              href={github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xl w-10 h-10 rounded-full bg-black flex justify-center items-center text-gray-400 hover:text-designColor duration-300"
            >
              <BsGithub />
            </a>
            <a
              href={live}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xl w-10 h-10 rounded-full bg-black flex justify-center items-center text-gray-400 hover:text-designColor duration-300"
            >
              <FaGlobe />
            </a>
          </div>
        </div>
        <p className="text-sm text-gray-300 tracking-wide leading-relaxed group-hover:text-gray-100 transition-colors duration-300">
          {des}
        </p>
      </div>
    </div>
  );
};

export default ProjectsCard;